
import React, { useEffect, useState } from "react";

// Components
import NavbarAndSidebarLayout from "~/layouts/NavbarAndSidebarLayout";
import PageHeader from "~/common/components/PageHeader";
import ModalTemplate from "~/common/components/ModalPortal/ModalTemplate";

// Assets
import "~/assets/sass/pages/mypage/plugin/plugin.scss";
import "~/assets/sass/pages/mypage/plugin/detailModal.scss";

// Tab Pages
import useRequest from "~/common/hooks/useRequest";
import { API_STATE } from "~/common/constants/state";
import PluginDetailModal from "./PluginDetailModal";
import { useTranslation } from "react-i18next";


const Plugin = () => {

    const { t, i18n } = useTranslation();
    const [pluginDetailModal, setPluginDetailModal] = useState(false);
    // const tabMenuList = [
    // 	{ id: "desc", title: "설명" },
    // 	{ id: "screenshot", title: "스크린샷" },
    // 	{ id: "update", title: "업데이트" },
    // ];

    // plugin List
    const pluginListRequest = useRequest("get", "/vc/plugin/list");
    const [pluginList, setPluginList] = useState([]);

    // plugin Detail
    const [selectedPlugin, setSelectedPlugin] = useState({});
    const [pluginTitle, setPluginTitle] = useState("");
    const pluginDetailRequest = useRequest("get", `vc/plugin`);

    useEffect(() => {
        pluginListRequest.singleCall();
    }, [pluginListRequest]);

    useEffect(() => {
        switch (pluginListRequest.state) {
            case API_STATE.done:
                let newList = [];
                pluginListRequest.response.forEach((d) => {
                    newList.push({
                        ...d,
                        tagList: d.tag ? d.tag.split("|") : [],
                        engTagList: d.engTag ? d.engTag.split("|") : [],
                    });
                });
                setPluginList(newList);
                break;
            case API_STATE.error:
                console.log("error", pluginListRequest.error);
                break;
            default:
                break;
        }
    }, [pluginListRequest.state, pluginListRequest.response, pluginListRequest.error]);

    const openModal = (idx) => {
        pluginDetailRequest.call(idx, "path");
    };

    useEffect(() => {
        switch (pluginDetailRequest.state) {
            case API_STATE.done:
                let newData = pluginDetailRequest.response.data;

                setPluginTitle(pluginDetailRequest.response.data.name);
                setSelectedPlugin(newData);
                setPluginDetailModal(true);
                break;
            case API_STATE.error:
                console.log("error", pluginDetailRequest.error);
                alert(t("common.commonWord.alert.wait2"));
                break;
            default:
                break;
        }
    }, [pluginDetailRequest.state, pluginDetailRequest.response, pluginDetailRequest.error]);


    return(
        <NavbarAndSidebarLayout menu={["plugin", "list"]} type="main">
            <PageHeader />
            <div className="c__cardRow">
                {pluginList &&
                    pluginList.map((item) => (
                        <div className="c__card" key={item.idx} onClick={() => openModal(item.idx)}>
                            <div className="top">
                                <div className="img-wrap">
                                    <img
                                        src={item.thumbImg}
                                        alt={i18n.language === "ko" ? item.name : item.engName}
                                    />
                                </div>
                                <div className="detail-wrap">
                                    <div className="title-wrap">
                                        <h3>{i18n.language === "ko" ? item.name : item.engName}</h3>
                                        {item.license ? (
                                            <span className="price-free">
												{t("pages.myPage.PluginPage.price-free")}
											</span>
                                        ) : (
                                            <span className="price">
												{t("pages.myPage.PluginPage.price")}
											</span>
                                        )}
                                    </div>
                                    <div
                                        className={`plugin-detail ${
                                            item.tagList?.length !== 0 ? "tag" : ""
                                        }`}
                                    >
                                        <p>
                                            {i18n.language === "ko"
                                                ? item.introduction
                                                : item.engIntroduction}
                                        </p>
                                        <div className="plugin-tag">
                                            {i18n.language === "ko"
                                                ? item.tagList.map((tag, tag_index) => (
                                                    <span key={tag_index}>{tag}</span>
                                                ))
                                                : item.engTagList.map((engTag, engTag_index) => (
                                                    <span key={engTag_index}>{engTag}</span>
                                                ))}
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="bottom">
								<span className="usage">
									{item.viewMode
                                        ? t("pages.myPage.PluginPage.usage")
                                        : t("pages.myPage.PluginPage.unused")}
								</span>
                            </div>
                        </div>
                    ))}
                <div className="c__card">
                    <div className="top">
                        <div className="img-wrap">
                            <img
                                src="https://invest-startup.s3.ap-northeast-2.amazonaws.com/shop/plugin/plugin-feed.jpg"
                                alt={t("pages.myPage.PluginPage.img-wrap")}
                            />
                        </div>
                        <div className="detail-wrap">
                            <div className="title-wrap">
                                <h3>{t("pages.myPage.PluginPage.h3")}</h3>
                                <span className="price-free">
									{t("pages.myPage.PluginPage.price-free")}
								</span>
                            </div>
                            <div className="plugin-detail">
                                {t("pages.myPage.PluginPage.pluginDetail")}
                            </div>
                        </div>
                    </div>
                    <div className="bottom">
                        <span className="unused">{t("pages.myPage.PluginPage.unused")}</span>
                    </div>
                </div>
            </div>
            <ModalTemplate
                title={pluginTitle}
                modalState={pluginDetailModal}
                setModalToggle={setPluginDetailModal}
                className="plugin-detail-modal"
            >
                <PluginDetailModal selectedPlugin={selectedPlugin} />
            </ModalTemplate>
        </NavbarAndSidebarLayout>
    )
}

export default Plugin
